import * as yup from 'yup'
import { getEmailSchema, getTeamSchema, getNameSchema } from 'src/deps'
import { isB2B2C } from 'src/utils'

/**
 * This function is to validate first name, last name, email address and team
 * @date 2023/8/15 - 20:00:14
 *
 * @param { Object } props - This is sample props
 * @param { boolean } props.active - Active parameter
 * @returns {*}
 */
function getValidationSchema(props) {
  const { active = false } = props
  let validation = {}
  if (active) {
    validation = Object.assign(
      validation,
      getNameSchema(),
      getNameSchema({ inputName: 'lastName', isLastName: true }),
      getEmailSchema({ inputName: 'userEmailAddress' })
      // getRequiredSchema({
      //   inputName: 'userRole',
      // })
    )
    if (!isB2B2C()) {
      validation = Object.assign(
        validation,
        getTeamSchema({
          inputName: 'userTeam',
        })
      )
    }
  }

  const inviteUserValidationSchema = yup.object(validation)
  return inviteUserValidationSchema
}

export { getValidationSchema }
